import {SETTINGS, MANAGEMENT, APPOINTMENTS, ACTIVATION, CLINICIANS, VOUCHER, ANALYTICS, STAFF_ACTIVITY} from './svgIcons';
import { SECTIONS } from "./sections";

/**
 * The menu for the signed-in admin. Computed on every render from the section access in force
 * (SectionAccessContext) - never once at module load, which kept the previous user's menu after
 * a sign-in in the same tab.
 *
 * @param {Object<string, boolean>} sections which gated sections are visible
 */
export function getSidebarLinks(sections) {
    const visible = key => Boolean(sections && sections[key]);

    return [
        {to: "/appointments", label: "Appointments", icon: APPOINTMENTS},
        {to: "/patients-management", label: "Patients management", icon: MANAGEMENT},
        visible(SECTIONS.ACTIVATION_CODES) && {to: "/activation-code", label: "Activation code", icon: ACTIVATION},
        visible(SECTIONS.VOUCHERS) && {to: "/voucher", label: "Voucher code", icon: VOUCHER},
        visible(SECTIONS.CLINICIANS) && {to: "/clinicians-management", label: "Clinicians management", icon: CLINICIANS},
        // { to: "/user-analytics", label: "User analytics", icon: ANALYTICS },
        {to: "/settings", label: "Settings", icon: SETTINGS},
        visible(SECTIONS.STATISTICS) && {to: "/statistics", label: "Statistics", icon: ANALYTICS},
        // Super admins only, always (never opened by Section access).
        visible(SECTIONS.STAFF_ACTIVITY) && {to: "/staff-activity", label: "Staff activity", icon: STAFF_ACTIVITY},
    ].filter(Boolean);
}
